import { appStore } from '@pendwa/common-browser/core/appStore/index.js';
import { getAbsoluteUrlToSite } from '@pendwa/common-browser/utils/getAbsoluteUrlToSite.js';
import cuid from 'cuid';

const KEY_STATE_STRING = 'f-s';

export const facebookSDKLogin = async (): Promise<any> => {
  const state_string = cuid.slug();
  appStore.set(KEY_STATE_STRING, state_string);

  window.location.href = `https://www.facebook.com/v${
    browserRootConfig.social.facebook.app.api_version
  }/dialog/oauth?client_id=${
    browserRootConfig.social.facebook.app.app_id
  }&redirect_uri=${getAbsoluteUrlToSite(
    window.location.pathname
  )}&response_type=token&state=${state_string}&scope=email,public_profile`;
};

export const isValidFacebookLoginRedirect = (state_string: string) =>
  state_string && appStore.get(KEY_STATE_STRING) === state_string;
